var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6154 7.26C9.83804 7.26 8.63467 6.37611 7.36741 6.40805C5.69547 6.42935 4.16197 7.37714 3.29938 8.87869C1.56354 11.8924 2.85211 16.3438 4.54534 18.7932C5.37599 19.9859 6.35572 21.3277 7.65494 21.2851C8.9009 21.2319 9.36947 20.4758 10.8817 20.4758C12.3832 20.4758 12.8092 21.2851 14.1297 21.2532C15.4715 21.2319 16.3235 20.0391 17.1435 18.8358C18.0912 17.4514 18.4853 16.1096 18.5066 16.035C18.4746 16.0244 15.8975 15.034 15.8655 12.0522C15.8442 9.56024 17.8996 8.36752 17.9954 8.31428C16.824 6.59974 15.0242 6.40805 14.3959 6.36546C12.7559 6.23767 11.3822 7.26 10.6154 7.26ZM13.3843 4.74677C14.0765 3.91612 14.5344 2.75535 14.4066 1.60522C13.4162 1.64782 12.2235 2.26548 11.51 3.09613C10.871 3.83093 10.3173 5.013 10.4663 6.14182C11.5632 6.22702 12.6921 5.57741 13.3843 4.74677Z",
    fill: "#EBF8DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.714c1fd2ce89b3e809291ff5024cc025.svg";
export { ForwardRef as ReactComponent };